import {Product} from './Product';
import {VatRateService} from '../../services/vat-rate.service';
import {ContractItemTransfer} from './ContractItemTransfer';
import {ContractItemType} from './ContractItemType';
import {ContractItem} from './ContractItem';

export class DeploymentContractItem extends ContractItem {

    name = 'Montáž';
    order = 9998;
    hirePrice = 0;
    vat = VatRateService.VAT21;
    type: ContractItemType = ContractItemType.deployment;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/DeploymentContractItem.ts